module.exports = {
  "zones": {
    "Europe/Monaco": ["z", {
      "wallclock": 220924800000,
      "format": "CE%sT",
      "abbrev": "CET",
      "offset": 3600000,
      "posix": 220921200000,
      "save": 0,
      "rules": "EU"
    }, {
      "wallclock": -766616400000,
      "format": "CE%sT",
      "abbrev": "CET",
      "offset": 3600000,
      "posix": -766623600000,
      "save": 0,
      "rules": "France"
    }, {
      "wallclock": -1855958400000,
      "format": "WE%sT",
      "abbrev": "WET",
      "offset": 0,
      "posix": -1855958961000,
      "save": 0,
      "rules": "France"
    }, {
      "wallclock": -2486678400000,
      "format": "PMT",
      "abbrev": "PMT",
      "offset": 561000,
      "posix": -2486680172000,
      "save": 0
    }, {
      "wallclock": -1.7976931348623157e+308,
      "format": "LMT",
      "abbrev": "LMT",
      "offset": 1772000,
      "posix": -1.7976931348623157e+308,
      "save": 0
    }]
  },
  "rules": {
    "EU": [{
      "from": 1981,
      "to": 1.7976931348623157e+308,
      "month": 2,
      "day": [0, -31],
      "time": 60,
      "clock": "posix",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1996,
      "to": 1.7976931348623157e+308,
      "month": 9,
      "day": [0, -31],
      "time": 60,
      "clock": "posix",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1985,
      "to": 1995,
      "month": 8,
      "day": [0, -30],
      "time": 60,
      "clock": "posix",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1984,
      "to": 1984,
      "month": 8,
      "day": [0, -30],
      "time": 60,
      "clock": "posix",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1982,
      "to": 1983,
      "month": 8,
      "day": [0, -30],
      "time": 60,
      "clock": "posix",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1981,
      "to": 1981,
      "month": 8,
      "day": [0, -30],
      "time": 60,
      "clock": "posix",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1977,
      "to": 1980,
      "month": 3,
      "day": [0, 1],
      "time": 60,
      "clock": "posix",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1979,
      "to": 1980,
      "month": 8,
      "day": [0, -30],
      "time": 60,
      "clock": "posix",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1978,
      "to": 1978,
      "month": 9,
      "day": [7, 1],
      "time": 60,
      "clock": "posix",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1977,
      "to": 1977,
      "month": 8,
      "day": [0, -30],
      "time": 60,
      "clock": "posix",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }],
    "France": [{
      "from": 1976,
      "to": 1976,
      "month": 2,
      "day": [7, 28],
      "time": 60,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1976,
      "to": 1976,
      "month": 8,
      "day": [7, 26],
      "time": 60,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1945,
      "to": 1945,
      "month": 3,
      "day": [7, 2],
      "time": 120,
      "clock": "wallclock",
      "save": 120,
      "letter": "M",
      "saved": 3600000
    }, {
      "from": 1945,
      "to": 1945,
      "month": 8,
      "day": [7, 16],
      "time": 180,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 0
    }, {
      "from": 1944,
      "to": 1944,
      "month": 3,
      "day": [7, 3],
      "time": 120,
      "clock": "wallclock",
      "save": 120,
      "letter": "M",
      "saved": 3600000
    }, {
      "from": 1944,
      "to": 1944,
      "month": 9,
      "day": [7, 8],
      "time": 60,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 7200000
    }, {
      "from": 1943,
      "to": 1943,
      "month": 2,
      "day": [7, 29],
      "time": 120,
      "clock": "wallclock",
      "save": 120,
      "letter": "M",
      "saved": 3600000
    }, {
      "from": 1943,
      "to": 1943,
      "month": 9,
      "day": [7, 4],
      "time": 180,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 7200000
    }, {
      "from": 1942,
      "to": 1942,
      "month": 2,
      "day": [7, 9],
      "time": 0,
      "clock": "wallclock",
      "save": 120,
      "letter": "M",
      "saved": 3600000
    }, {
      "from": 1942,
      "to": 1942,
      "month": 10,
      "day": [7, 2],
      "time": 180,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 7200000
    }, {
      "from": 1941,
      "to": 1941,
      "month": 4,
      "day": [7, 5],
      "time": 0,
      "clock": "wallclock",
      "save": 120,
      "letter": "M",
      "saved": 3600000
    }, {
      "from": 1941,
      "to": 1941,
      "month": 9,
      "day": [7, 6],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 7200000
    }, {
      "from": 1940,
      "to": 1940,
      "month": 1,
      "day": [7, 25],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1939,
      "to": 1939,
      "month": 3,
      "day": [7, 15],
      "time": 1380,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1939,
      "to": 1939,
      "month": 10,
      "day": [7, 18],
      "time": 1440,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1922,
      "to": 1938,
      "month": 9,
      "day": [6, 1],
      "time": 1440,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1938,
      "to": 1938,
      "month": 2,
      "day": [7, 26],
      "time": 1380,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1937,
      "to": 1937,
      "month": 3,
      "day": [7, 3],
      "time": 1380,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1936,
      "to": 1936,
      "month": 3,
      "day": [7, 18],
      "time": 1380,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1935,
      "to": 1935,
      "month": 2,
      "day": [7, 30],
      "time": 1380,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1934,
      "to": 1934,
      "month": 3,
      "day": [7, 7],
      "time": 1380,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1933,
      "to": 1933,
      "month": 2,
      "day": [7, 25],
      "time": 1380,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1932,
      "to": 1932,
      "month": 3,
      "day": [7, 2],
      "time": 1380,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1931,
      "to": 1931,
      "month": 3,
      "day": [7, 18],
      "time": 1380,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1930,
      "to": 1930,
      "month": 3,
      "day": [7, 12],
      "time": 1380,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1929,
      "to": 1929,
      "month": 3,
      "day": [7, 20],
      "time": 1380,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1928,
      "to": 1928,
      "month": 3,
      "day": [7, 14],
      "time": 1380,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1927,
      "to": 1927,
      "month": 3,
      "day": [7, 9],
      "time": 1380,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1926,
      "to": 1926,
      "month": 3,
      "day": [7, 17],
      "time": 1380,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1925,
      "to": 1925,
      "month": 3,
      "day": [7, 4],
      "time": 1380,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1924,
      "to": 1924,
      "month": 2,
      "day": [7, 29],
      "time": 1380,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1923,
      "to": 1923,
      "month": 4,
      "day": [7, 26],
      "time": 1380,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1922,
      "to": 1922,
      "month": 2,
      "day": [7, 25],
      "time": 1380,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1921,
      "to": 1921,
      "month": 2,
      "day": [7, 14],
      "time": 1380,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1921,
      "to": 1921,
      "month": 9,
      "day": [7, 25],
      "time": 1440,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1920,
      "to": 1920,
      "month": 1,
      "day": [7, 14],
      "time": 1380,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1920,
      "to": 1920,
      "month": 9,
      "day": [7, 23],
      "time": 1440,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1916,
      "to": 1919,
      "month": 9,
      "day": [0, 1],
      "time": 1440,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1919,
      "to": 1919,
      "month": 2,
      "day": [7, 1],
      "time": 1380,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1918,
      "to": 1918,
      "month": 2,
      "day": [7, 9],
      "time": 1380,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1917,
      "to": 1917,
      "month": 2,
      "day": [7, 24],
      "time": 1380,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1916,
      "to": 1916,
      "month": 5,
      "day": [7, 14],
      "time": 1380,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }]
  }
};